import { gql } from '@apollo/client';

export const GET_AGENT_PROMPTS_LIST = gql`
  query AgentPrompts($params: FindAgentPromptListInput!) {
    agentPrompts(params: $params) {
      success
      message
      errors
      data {
        prompts {
          id
          agentConfigId
          businessDomain
          systemRole
          mainTask
          instructions
          restrictions
          responseFormatRules
          promptInput
          contextVariables
          fewShotExamples
          isActive
          createdAt
          createdBy
        }
        hasMorePages
        nextPage
        totalPages
        totalRecords
      }
    }
  }
`;

export const GET_AGENT_PROMPT = gql`
  query AgentPrompt($params: FindAgentPrompt!) {
    agentPrompt(params: $params) {
      success
      message
      errors
      data {
        id
        agentConfigId
        businessDomain
        systemRole
        mainTask
        instructions
        restrictions
        responseFormatRules
        promptInput
        contextVariables
        fewShotExamples
        isActive
        createdAt
        createdBy
      }
    }
  }
`;
